import {type SlotSize, cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import tailSrc from '../../assets/BottomCenter.svg'
import pvzSrc from '../../assets/night/pvz.svg'
import yandexMarketSrc from '../../assets/yandexMarket.png'
import type {PickupPointType} from '../../types'

export const sidePanel = css`
  && {
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    overflow: initial;
    width: initial;
    inset: ${spacing('auto', 1, 1, 1)};
  }
`
export const backdrop = css`
  display: none;
`
export const markerRoot = css`
  transform: translate(-50%, -100%);
`
export const slotMarker = css`
  background: ${cssTheme.default.day.background};
  box-shadow: ${cssTheme.shadows.bottomClose};
`
export const slotMarkerSize: Partial<Record<SlotSize, string>> = {
  xs: css`
    border-radius: ${spacing(1.25)};
  `,
  m: css`
    border-radius: ${spacing(2)};
  `,
}
export const icon = css`
  width: 100%;
  height: 100%;
  border-color: ${cssTheme.default.day.background};
  border-style: solid;
  background: no-repeat center center ${cssTheme.default.day.background};
`
export const iconType: Partial<Record<PickupPointType, string>> = {
  yandex_market: css`
    background-image: url(${yandexMarketSrc});
    background-size: contain;
  `,
  pickup_point: css`
    background-image: url(${pvzSrc});
    background-color: ${cssTheme.colors.deliveryGrey[450]};
  `,
}
export const iconSize: Partial<Record<SlotSize, string>> = {
  xs: css`
    border-radius: ${spacing(1.25)};
    border-width: ${spacing(0.25)};
  `,
  m: css`
    border-radius: ${spacing(2)};
    border-width: ${spacing(0.5)};
  `,
}
export const tail = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  :before {
    content: '';
    width: ${spacing(3)};
    height: ${spacing(1)};
    background: url(${tailSrc}) center center no-repeat;
  }
  :after {
    content: '';
    width: ${spacing(1.5)};
    height: ${spacing(1.5)};
    background: ${cssTheme.default.day.background};
    border: ${spacing(0.375)} solid ${cssTheme.default.day.text};
    border-radius: 50%;
  }
`
